import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  useInitUser,
  useRecoverPasswordEmail
} from '../../hooks/useUser';
import { useAllowedCountries } from '../../hooks/useRoutes'
import { StyledForm } from '../shared/simple/StyledForm';
import { Button } from '../shared/simple/Button'
import { Label } from '../shared/simple/Label'
import { LoaderSpinner } from '../shared/simple/LoaderSpinner'
import { RouterLink } from '../shared/simple/RouterLink'
import { Div, StyledImage, StyledLogo, StyledRow } from './styled';
import { routes } from '../../constants/routes';
import { Input } from '../shared/Input';
import { LinkLogo } from './LinkLogo';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SlideCaptchaModal from '../shared/slide-captcha-modal/SlideCaptchaModal';
import ImageAds from '../../assets/images/login/wisenroll.webp';

/**
 * Recover Password Component
 * @component
 * @returns
 */
export const RecoverPasswordEmail = () => {
  const { t } = useTranslation();
  const { allowed } = useAllowedCountries();
  const { selectedProduct } = useSelector(state => state.user);
  const {
    appOrigin,
    isSlideModalOpen,
    loading,
    onSubmit,
    setIsSlideModalOpen,
    values
  } = useInitUser(allowed);
  const { errors, handleSubmit, onRecover, register } = useRecoverPasswordEmail();

  return (
    <Div>
      <LinkLogo />
      <Container>
        <StyledImage
          className="d-xs-block d-md-none"
          src={ ImageAds }
        />
        <StyledLogo
          className="d-xs-block d-md-none"
          src={ selectedProduct?.image_ads }
        />
        <StyledRow className="justify-content-md-center">
          <StyledForm
            className="col-md-10 col-xs-12 col-lg-6 col-xl-5"
            onSubmit={ handleSubmit(onSubmit) }
          >
            <h1 className="pb-4">{ t("password.title") }</h1>
            <Input
              autoComplete="off"
              disabled={ loading }
              label={ t("common.email") }
              message={ errors.email?.message }
              name={ register("email").name }
              placeholder={ t("common.emailExample") }
              register={ register("email") }
              type="email"
            />
            {loading
              ? (
                <LoaderSpinner />
              ) : (
                <Button
                  className="btn mb-0"
                  disabled={ loading }
                  color="first"
                  type="submit"
                  name="btn_recover"
                >
                  { t("common.continue") }
                </Button>
              )
            }
            <Label className="wantText">
              {!loading && <>
                { t("password.wantToLogin") }&nbsp;
                <RouterLink
                  className="p-0 col-12"
                  to={ routes.login(appOrigin) }
                  color="third"
                  disabled={ loading }
                >
                  { t("login.buttonLogIn") }
                </RouterLink>
              </>}
            </Label>
          </StyledForm>
        </StyledRow>
      </Container>
      <SlideCaptchaModal
        isOpen={ isSlideModalOpen }
        onRequestClose={ () => setIsSlideModalOpen(false) }
        onSuccess={ () => onRecover(values)}
      />
    </Div>
  );
};